import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../Field';

let Quote = require('../Managers/Quote');

class AddApplicantFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showManualWarning: false,
            productSelection: null,
            isRentGuaranteeProduct: false,
            productHasRentGuarantee: false,
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentDidMount() {
        if (!window.uorn(JSON.parse(window.localStorage.getItem('errorArray')))) {
            let errorResponse = JSON.parse(window.localStorage.getItem('errorArray'));
            for (let v in errorResponse) {
                if (v === 'email') {
                    $('html, body').animate({
                        scrollTop: $("#email-entry").first().offset().top - $('header.site-header').height()
                    }, 500);
                }
            }
        }
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    /**
     * Sets the product type and resets the selected product ID
     *
     * @param v
     */
    setProductType(v) {
        this.setState({
            productSelection: null,
            isRentGuaranteeProduct: v
        });
    }

    /**
     * Sets the product ID
     * Sets `productHasRentGuarantee` into state for if the chosen product
     * requires the use to choose a length of cover
     */
    setProduct(productId) {
        let products = JSON.parse(window.localStorage.getItem('AgentProducts'));

        products.map(p => {
            if (p.productId == productId) {
                this.setState({
                    isRentGuaranteeProduct: p.hasRentGuarantee
                });
            }
        });

        this.setState({
            productSelection: productId
        });

        // determine if we need length of cover
        const productHasRentGuarantee = this.props.products.some(p => {
            return (p.productId == productId && p.hasRentGuarantee);
        });

        this.setState({ productHasRentGuarantee });
    }

    /**
     * Sets the state for showing or hiding the obtainFinancialReferences
     * question
     */
    setAdvancedPayment(v) {
        this.setState({ showFinancialReferencesQuestion: v });
    }

    getChildInputComponents() {
        return this.inputComponents;
    }

    buildProducts() {
        return this.props.products.map(p => {
            return {
                value: p.productId,
                text: p.name.replace('Rent Guarantee', '')
            };
        });
    }

    render() {
        return(
            <div>
                {this.props.type !== 'guarantor' ?
                    <div>
                        <div>
                            {this.props.products.length > 0 ?
                                <Field
                                    question="Product type"
                                    fieldName="productSelection"
                                    type="button-choice"
                                    options={this.buildProducts()}
                                    callbackFunction={this.setProduct.bind(this)}
                                    // helpText="Find out more about our products..."
                                    dataValidation="required_field"
                                    storageKey="productId"
                                    source={this.props.source}
                                    loadValues={true}
                                    loadingKey={this.props.source + '.productId'}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                            : null}

                            {this.state.productHasRentGuarantee ?
                                <Field
                                    question="Length of cover"
                                    fieldName="coverLength"
                                    type="button-choice"
                                    options={[
                                        {
                                            value: '6',
                                            text: '6 Months'
                                        },
                                        {
                                            value: '12',
                                            text: '12 Months'
                                        },
                                    ]}
                                    dataValidation="required_field"
                                    source={this.props.source}
                                    storageKey="policyLength"
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                            : null}
                        </div>
                    </div>
                : null}

                <Field
                    type="button-choice"
                    question="Title"
                    fieldName="title"
                    options={[
                        {
                            value: 'Mr',
                            text: 'Mr'
                        },
                        {
                            value: 'Mrs',
                            text: 'Mrs'
                        },
                        {
                            value: 'Miss',
                            text: 'Miss'
                        },
                        {
                            value: 'Ms',
                            text: 'Ms'
                        },
                        {
                            value: 'Mx',
                            text: 'Mx'
                        },
                        {
                            value: 'Dr',
                            text: 'Dr.'
                        }
                    ]}
                    otherOptions={{
                        onOtherCallback: () => {
                            this.setState({ isOtherTitleNeeded: true });
                        },
                        offOtherCallback: () => {
                            this.setState({ isOtherTitleNeeded: false });
                        },
                        clearValueOnOther: true
                    }}
                    source={this.props.source}
                    storageKey="title"
                    loadValues={true}
                    dataValidation="required_field"
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                {this.state.isOtherTitleNeeded === true ?
                    <Field
                        type="text"
                        fieldName={'otherTitle'}
                        question="Other title"
                        maxLength={24}
                        dataValidation="required_field"
                        source={this.props.source}
                        hasBorder={false}
                        hasPadding={false}
                        storageKey="title"
                        loadValues={true}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                    />
                : null}

                <Field
                    type="text"
                    fieldName={'firstName'}
                    question="First name"
                    maxLength={35}
                    storeResponse={true}
                    dataValidation="alpha_and_space_only"
                    source={this.props.source}
                    storageKey="firstName"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                    forcibleValidation
                />

                <Field
                    type="text"
                    fieldName={'lastName'}
                    question="Last name"
                    maxLength={35}
                    storeResponse={true}
                    dataValidation="alpha_and_space_only"
                    source={this.props.source}
                    storageKey="lastName"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                    forcibleValidation
                />

                {!this.props.agentStep ?
                    <Field
                        type="text"
                        fieldName={'mobile'}
                        maxLength={11}
                        question="Mobile number"
                        dataValidation="mobile_number.non_mandatory"
                        labelExtra="Mobile number is used to send updates on the application, this must be a UK based number"
                        source={this.props.source}
                        storageKey="mobile"
                        loadValues={true}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                : null }

                <div id="email-entry">
                    <Field
                        type="email"
                        fieldName={'email'}
                        question="Email address"
                        dataValidation="email_address"
                        isValidCallbackFunction={(value) => {
                            // on the blur of the email, clear the confirm email
                            let oldValue = Quote.get('email', this.props.source);
                            if (oldValue != value) {
                                document.getElementById('emailConfirm').value = null;
                            }
                        }}
                        source={this.props.source}
                        storageKey="email"
                        maxLength={200}
                        loadValues={true}
                        ref={(instance) => {
                            this.childComponents.push(instance);
                            this.inputComponents.push(instance);
                        }}
                    />

                    <Field
                        type="email"
                        fieldName={'emailConfirm'}
                        question="Confirm email address"
                        source={this.props.source}
                        dataValidation="email_confirm"
                        storageKey="email_confirm"
                        hasPadding={false}
                        hasBorder={false}
                        loadValues={true}
                        dataMatchTo={'email'}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                    />
                </div>

                <Field
                    type="money"
                    fieldName={'rentShare'}
                    question="Share of rent"
                    dataValidation="2_decimal_money.non_mandatory"
                    source={this.props.source}
                    maxLength={10}
                    storageKey="rentShare"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                {/* We only ask this question if it's NOT a RG product AND NOT Insight */}
                {this.state.productSelection && this.state.productSelection !== 20 && this.state.isRentGuaranteeProduct === false ?
                    <Field
                        type="button-choice"
                        question="Will this tenant be paying their full rental amount in advance?"
                        labelExtra="For the full tenancy term, not just the first month's rent"
                        fieldName={'isRentPaidInAdvance'}
                        options={[
                            {
                                value: true,
                                text: 'Yes'
                            },
                            {
                                value: false,
                                text: 'No'
                            }
                        ]}
                        callbackFunction={this.setAdvancedPayment.bind(this)}
                        dataValidation="required_field"
                        source={this.props.source}
                        storageKey="isRentPaidInAdvance"
                        loadValues={true}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                    />
                : null}

                {this.state.showFinancialReferencesQuestion ?
                    <Field
                        type="button-choice"
                        question="Do you require financial references?"
                        fieldName={'obtainFinancialReference'}
                        options={[
                            {
                                value: true,
                                text: 'Yes'
                            },
                            {
                                value: false,
                                text: 'No'
                            }
                        ]}
                        supplementaryText={'<p>If the tenant is paying in advance financial references (from their employer, accountant etc.) are not essential to complete the application. Please let us know if you do not require these.</p>'}
                        dataValidation="required_field"
                        source={this.props.source}
                        storageKey="obtainFinancialReference"
                        loadValues={true}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                    />
                : null}
            </div>
        );
    }
}

AddApplicantFields.propTypes = {
    type:           PropTypes.string.isRequired,
    source:         PropTypes.string.isRequired,
    currentNumber:  PropTypes.number,
    products:       PropTypes.array,
    agentStep:      PropTypes.bool,
};

export default AddApplicantFields;



// WEBPACK FOOTER //
// ./src/components/Fragments/AddApplicantFields.js